import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import qs from 'qs';
import './slim-header';
import Sticky from 'react-stickynode';
import uiActions from 'state/actions/ui';
import SearchIcon from '@tradera/tradera-ui/icons/search.svg?jsx';
import NotificationPortal from '../portals/notification-portal';
import ModalPortal from '../portals/modal-portal';
import isTouch from 'utils/is-touch';
import breakpoints from 'utils/breakpoints';
import STRINGS from 'constants/strings';
import { trackHamburgerClick } from './site-header.analytics';
import pageActions from '../../state/actions/page';
import { trackSearchCategoryChanges } from '../search/search.analytics';
import { hot } from 'react-hot-loader';
import {
    Search,
    MyTraderaMenu,
    SignInModal,
    UserLink,
    DropdownMenu,
    SignUpLink,
    SellingLink,
    CategoryLink,
    WishlistLink,
    OngoingAuctionsLink,
    TraderaLogo,
    ToBuyLink,
    ToSellLink,
    CartLink,
    MultiCurrencyTopMenuButton,
    MessagingModal
} from 'components';

const isTouchDevice = isTouch();
const isTouchWithTabletSize =
    breakpoints.isVisible(breakpoints.siteheaderportrait) && isTouchDevice;
class SiteHeader extends Component {
    static propTypes = {
        initData: PropTypes.object.isRequired,
        cartItems: PropTypes.string,
        cartSum: PropTypes.string,
        currencies: PropTypes.array,
        isCurrencyChosenByUser: PropTypes.bool,
        messagingThreads: PropTypes.object,
        searchQuery: PropTypes.string,
        dispatch: PropTypes.func,
        currentSearchCategory: PropTypes.object,
        preferredCurrency: PropTypes.string,
        multiCurrencyDesktopOpenId: PropTypes.string,
        categoryPath: PropTypes.array,
        allCategories: PropTypes.array,
        currentCategoryId: PropTypes.number
    };

    static displayName = 'SiteHeader';

    constructor(props) {
        super(props);
        this.state = {
            hoverUser: false,
            showSearch: props.initData.hasSearch,
            autoFocusSearch: false
        };
    }

    componentDidMount() {
        const {
            dispatch,
            initData: { isLoggedIn, featureSwitches }
        } = this.props;
        if (featureSwitches['messaging'] && isLoggedIn) {
            dispatch(uiActions.fetchMessagingNotifications());
        }
        // Scroll one pixel to force react-sticky to get the correct scroll position on mount
        setTimeout(() => {
            window.scrollTo(0, -1);
        }, 100);
    }

    handleClickSearch = () => {
        this.setState(prevState => ({
            ...prevState,
            showSearch: !prevState.showSearch,
            autoFocusSearch: !prevState.showSearch
        }));
    };

    handleMouseOverUser = () => {
        if (!isTouchDevice) {
            // IF not needed since Touch-devices cant hover? Verify when reacts event is triggered
            this.setState(prevState => ({
                ...prevState,
                hoverUser: true
            }));
        }
    };
    handleMouseOutUser = () => {
        if (!isTouchDevice) {
            this.setState(prevState => ({
                ...prevState,
                hoverUser: false
            }));
        }
    };

    handleClickUser = evt => {
        const {
            initData: { featureSwitches, isLoggedIn }
        } = this.props;

        //not logged in
        if (featureSwitches['login-anywhere'] && !isLoggedIn) {
            evt.preventDefault();
            this.preventNavigationAndShowLogin(evt, '/my/overview');
        }

        //If tablet user we wish to show the dropdown
        if (isTouchWithTabletSize) {
            evt.preventDefault();
            this.setState(prevState => ({
                ...prevState,
                hoverUser: !prevState.hoverUser
            }));
        }
    };

    handleHamburgerClick = () => {
        const event = new Event('ui:site-header:on-hamburger-click');
        document.dispatchEvent(event);
        trackHamburgerClick();
    };

    //Prevent Default and show login, if not logged in
    preventNavigationAndShowLogin = (event, redirect) => {
        const {
            initData: { featureSwitches, isLoggedIn }
        } = this.props;
        if (featureSwitches['login-anywhere'] && !isLoggedIn) {
            event.preventDefault();
            this.handleLoginClick(redirect);
        }
    };

    handleLoginClick = (redirectUrl = false) =>
        this.props.dispatch(
            uiActions.signIn({
                redirectUrl
            })
        );

    hideHowToSell = () => {
        const {
            initData: {
                isLoggedIn,
                featureSwitches: { 'how-to-sell-page': showHowToSell }
            }
        } = this.props;
        return !isLoggedIn && showHowToSell;
    };

    handleCategoryChange = evt => {
        const { dispatch } = this.props;
        const selectBox = evt.target;
        const selectedValue = parseInt(selectBox.value, 10);

        trackSearchCategoryChanges(evt);
        dispatch(pageActions.setCurrentCategoryId(selectedValue));
    };

    render() {
        const {
            initData,
            initData: {
                isLoggedIn,
                memberId,
                memberAlias,
                cleanedMemberAlias,
                searchParams,
                searchUrl,
                facebookId,
                paymentSettings,
                featureSwitches: {
                    'couponation-nav-link': showCouponationMenu,
                    messaging: showMessagingLink
                },
                pageName
            },
            currentSearchCategory,
            searchQuery,
            cartItems,
            cartSum,
            dispatch,
            preferredCurrency,
            currencies,
            isCurrencyChosenByUser,
            multiCurrencyDesktopOpenId,
            messagingThreads,
            categoryPath,
            allCategories,
            currentCategoryId
        } = this.props;

        const { showSearch, autoFocusSearch } = this.state;

        const showPayments2Menu =
            paymentSettings && paymentSettings.showPayments2Menu;
        const showKlarnaMenu =
            paymentSettings && paymentSettings.showKlarnaMenu;
        const formattedCartItems = parseInt(cartItems, 10);
        const { threadsUnread } = messagingThreads;
        const shouldShowHideToSell = this.hideHowToSell();
        const hasStickyHeader = !pageName.includes('MyTradera');

        return (
            <Sticky
                enabled={hasStickyHeader}
                top={0}
                enableTransforms={true}
                activeClass="slim-header--sticky">
                <header className="slim-header container-fluid pl-0 pl-xl-2">
                    <div
                        className="row align-items-center mx-auto slim-header__content"
                        role="banner">
                        <DropdownMenu
                            cssClass="navbar order-1 slim-header__menu-option-divider--right"
                            initData={initData}
                            formattedCartItems={formattedCartItems}
                            threadsUnread={threadsUnread}
                            dispatch={dispatch}
                            preferredCurrency={preferredCurrency}
                            currencies={currencies}
                        />
                        <div className="slim-header__logo col-auto order-2">
                            <a
                                href="/"
                                className="slim-header__logo-link d-flex d-md-block">
                                <TraderaLogo />
                            </a>
                        </div>
                        <div
                            className={`col-12 order-4 order-md-3 col-md-auto d-none d-md-flex pl-3 pl-md-2 ${showSearch &&
                                'd-flex'} slim-header__search `}
                            id="slim-header__search">
                            <Search
                                categoryPath={categoryPath}
                                currentCategoryId={currentCategoryId}
                                allCategories={allCategories}
                                currentSearchCategory={currentSearchCategory}
                                searchTerm={searchQuery}
                                searchParams={searchParams}
                                searchUrl={searchUrl}
                                autoFocusSearch={autoFocusSearch}
                                handleCategoryChange={this.handleCategoryChange}
                            />
                        </div>
                        <nav
                            className="slim-header__menu col col-md-auto order-3 order-md-4 justify-content-end"
                            role="navigation">
                            <ul className="slim-header__menu-list row justify-content-end mb-0">
                                <li className="slim-header__menu-option d-none d-md-flex align-items-center">
                                    <CategoryLink isLoggedIn={isLoggedIn} />
                                </li>

                                <li className="slim-header__menu-option d-none d-md-flex align-items-center">
                                    {!shouldShowHideToSell ? (
                                        <SellingLink
                                            isLoggedIn={isLoggedIn}
                                            preventNavigationAndShowLogin={
                                                this
                                                    .preventNavigationAndShowLogin
                                            }
                                        />
                                    ) : (
                                        <ToSellLink
                                            isLoggedIn={isLoggedIn}
                                            preventNavigationAndShowLogin={
                                                this
                                                    .preventNavigationAndShowLogin
                                            }
                                        />
                                    )}
                                </li>
                                {isLoggedIn && (
                                    <li className="slim-header__menu-option d-flex align-items-center d-md-none">
                                        <OngoingAuctionsLink />
                                    </li>
                                )}
                                <li className="slim-header__menu-option d-flex align-items-center">
                                    {isLoggedIn ? (
                                        <WishlistLink
                                            isLoggedIn={isLoggedIn}
                                            preventNavigationAndShowLogin={
                                                this
                                                    .preventNavigationAndShowLogin
                                            }
                                        />
                                    ) : (
                                        <ToBuyLink
                                            isLoggedIn={isLoggedIn}
                                            preventNavigationAndShowLogin={
                                                this
                                                    .preventNavigationAndShowLogin
                                            }
                                        />
                                    )}
                                </li>
                                {formattedCartItems > 0 && (
                                    <li className="slim-header__menu-option slim-header__menu-option-divider d-none d-md-flex px-2 align-items-center">
                                        <CartLink
                                            isLoggedIn={isLoggedIn}
                                            formattedCartItems={
                                                formattedCartItems
                                            }
                                            cartSum={cartSum}
                                        />
                                    </li>
                                )}
                                <li
                                    className={`slim-header__menu-option d-flex align-items-center ${formattedCartItems <
                                        1 &&
                                        'slim-header__menu-option-divider'}`}>
                                    <UserLink
                                        isLoggedIn={isLoggedIn}
                                        memberAlias={memberAlias}
                                        facebookId={facebookId}
                                        mouseOver={this.handleMouseOverUser}
                                        mouseOut={this.handleMouseOutUser}
                                        handleClickUser={this.handleClickUser}
                                        threadsUnread={threadsUnread}
                                    />
                                    <MyTraderaMenu
                                        hoverUser={this.state.hoverUser}
                                        showPayments2Menu={showPayments2Menu}
                                        showKlarnaMenu={showKlarnaMenu}
                                        showCouponationMenu={
                                            showCouponationMenu
                                        }
                                        showMessagingLink={showMessagingLink}
                                        preventNavigationAndShowLogin={
                                            this.preventNavigationAndShowLogin
                                        }
                                        cleanedMemberAlias={cleanedMemberAlias}
                                        memberId={memberId}
                                        isLoggedIn={isLoggedIn}
                                        threadsUnread={threadsUnread}
                                    />
                                </li>
                                {!isLoggedIn && (
                                    <li className="slim-header__menu-option d-flex align-items-center">
                                        <SignUpLink />
                                    </li>
                                )}
                                <li className="slim-header__menu-option d-none d-md-flex align-items-center">
                                    <MultiCurrencyTopMenuButton
                                        dispatch={dispatch}
                                        preferredCurrency={preferredCurrency}
                                        currencies={currencies}
                                        isCurrencyChosenByUser={
                                            isCurrencyChosenByUser
                                        }
                                        openId={multiCurrencyDesktopOpenId}
                                    />
                                </li>
                                <li className="slim-header__menu-option d-flex d-md-none align-items-center">
                                    <button
                                        className="slim-header__search-button unbutton px-3 mr-2 d-flex align-items-center"
                                        style={
                                            showSearch ? { height: '80%' } : {}
                                        }
                                        aria-label={STRINGS.SEARCH}
                                        onClick={this.handleClickSearch}
                                        data-nav-search-button
                                        aria-hidden="true">
                                        <SearchIcon
                                            className="icon icon-md"
                                            style={{
                                                opacity: showSearch ? '0.6' : 1
                                            }}
                                        />
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </header>
                <Modals
                    props={this.props}
                    handleLoginClick={this.handleLoginClick}
                />
                {threadsUnread > 0 && (
                    <NotificationPortal>
                        <span className="side-menu-notifications-items">
                            {threadsUnread}
                        </span>
                    </NotificationPortal>
                )}
            </Sticky>
        );
    }
}

const Modals = ({ props }) => {
    const {
        initData,
        initData: {
            featureSwitches: { 'login-anywhere': loginAnywhere }
        },
        dispatch,
        signInModal,
        messagingModal,
        handleLoginClick
    } = props;

    const {
        open: signInModalOpen,
        redirectUrl: signInRedirectUrl
    } = signInModal;

    if (messagingModal.open === 'open') {
        return (
            <ModalPortal>
                <MessagingModal dispatch={dispatch} {...messagingModal} />
            </ModalPortal>
        );
    } else if (loginAnywhere && signInModalOpen === 'open') {
        return (
            <SignInModal
                initData={{
                    initData: {
                        ...initData,
                        pageName: 'Login'
                    }
                }}
                handleLoginClick={handleLoginClick}
                redirectURL={signInRedirectUrl}
                dispatch={dispatch}
            />
        );
    } else {
        return null;
    }
};

const mapStateToProps = (state, ownProps) => {
    // TODO: Get search state from a better place when global state has been refactored
    const currentSearchCategory =
        state.search &&
        state.search.filterCategories &&
        state.search.filterCategories.activeCategory;
    let searchQuery;
    // TODO: Get search query from refactored search state
    if (state.search && state.search.routing && state.search.routing.location) {
        const { q } = qs.parse(state.search.routing.location.search, {
            ignoreQueryPrefix: true
        });
        searchQuery = q;
    }
    const props = {
        initData: state.initData,
        currentSearchCategory,
        searchQuery,
        cartItems: ownProps.cartItems,
        currencies: state.initData.currencies,
        messagingThreads: state.ui.badges.messaging,
        signInModal: state.ui.signInModal,
        messagingModal: state.ui.messagingModal,
        categoryPath: state.page.categoryPath,
        allCategories: state.page.allCategories,
        currentCategoryId: state.page.currentCategoryId
    };
    if (state.multiCurrency) {
        props.isCurrencyChosenByUser =
            state.multiCurrency.isCurrencyChosenByUser;
        props.multiCurrencyDesktopOpenId = state.multiCurrency.desktopOpenId;
        props.preferredCurrency = state.multiCurrency.preferredCurrency;
    }
    return props;
};

export default hot(module)(connect(mapStateToProps)(SiteHeader));



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/site-header.jsx